export const AGENTS_UPDATE_KEY = 'agents';
export const GUARDS_UPDATE_KEY = 'guards';
export const MCP_TOOLS_UPDATE_KEY = 'mcp.tools';
